import {
  DefaultButton,
  Dialog,
  DialogFooter,
  PrimaryButton,
} from "@fluentui/react";
import { toast } from "components/FluentToast";
import { useDeleteFleetInsurerDefaultSetting } from "hooks/data/mutations/useDeleteFleetInsurerDefaultSetting";
import usePhraseActivationStatus from "hooks/usePhraseActivationStatus";
import React from "react";
import { useTranslation } from "react-i18next";
import { IFleetInsurerDefaultSetting } from "types/types";

export const DeleteDialog = ({
  deleteDialog,
  close,
}: {
  deleteDialog: {
    isOpen: boolean;
    setting: IFleetInsurerDefaultSetting;
  };
  close: () => void;
}) => {
  const { t } = useTranslation();
  const phraseActivated = usePhraseActivationStatus().activated;

  const { mutate: onDeleteFleetInsurerDefaultSetting, isLoading } =
    useDeleteFleetInsurerDefaultSetting();

  return (
    <Dialog
      hidden={!deleteDialog.isOpen}
      onDismiss={close}
      dialogContentProps={{
        title: t("greco.dialog.deleteTitle", {
          object: t("bfm.insurerDefaultSettings.label"),
        }),
      }}
      modalProps={{
        isBlocking: phraseActivated ? false : true,
      }}
    >
      {t("bfm.fleet.defaultSettings.delete.message")}
      <DialogFooter>
        <DefaultButton text={t("greco.cancel")} onClick={close} />
        <PrimaryButton
          disabled={isLoading}
          text={t("greco.delete")}
          onClick={async () => {
            onDeleteFleetInsurerDefaultSetting(
              {
                fleetId: deleteDialog.setting.fleetId,
                fleetInsurerSettingId:
                  deleteDialog.setting.fleetInsurerDefaultSettingId,
              },
              {
                onSuccess: () => {
                  toast.success(t("bfm.success"));
                  close();
                },
              }
            );
          }}
        />
      </DialogFooter>
    </Dialog>
  );
};
